import * as React from "react";
import Calendar from "react-calendar";

import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import {PrevArrowIcon, NextArrowIcon} from "../ui/icons/icons";
import {getDateObjectsFromUnix, setMemberFormCalendar} from "./memberFormSlice";

const minDate = new Date(2024, 1);
// const maxDate = new Date(2040, 1);

const MemberFileCalendar = () => {

  const dispatch = useAppDispatch();
  const {calendarDates} = useAppSelector((store) => store.memberFormState);

  const handleCalendarChange = (selectedDates:Date[]) => {
    const dates = selectedDates.map(date => date.getTime());
    dispatch(setMemberFormCalendar(dates));
  }

  // console.log("calendarDates", calendarDates);

  return (
    <div className="calendar">
      <div className="calender-title flex margin-b-15 text-center gray2 bold">
        <div className="flex-item">Start Plan</div>
        <div className="flex-item">End Plan</div>
      </div>
      <Calendar onChange={handleCalendarChange}
                showDoubleView={true}
                minDate={minDate}
                // maxDate={maxDate}
                showNeighboringCentury={false}
                showNeighboringDecade={false}
                prevLabel={<PrevArrowIcon/>}
                nextLabel={<NextArrowIcon/>}
                returnValue={"range"}
                selectRange={true}
                next2Label={null}
                prev2Label={null}
                value={getDateObjectsFromUnix(calendarDates)} />
    </div>
  )
}

export default MemberFileCalendar
